import { Common } from '@/services/Api/index';

export default {
  methods: {
    /**
     * Handles preorder redirect functionality
     * @param {string} location - The location where the redirect was triggered (e.g., 'sidebar', 'direct_link')
     * @param {Function} onSuccess - Optional callback for successful redirect
     * @param {Function} onError - Optional callback for error handling
     */
    handlePreOrderRedirect(location = 'unknown', onSuccess = null, onError = null) {
      // Push analytics events
      this.pushDataLayerEvent('ecommerce');
      this.pushDataLayerEvent('on_siparis_click', {
        location: location,
      });

      // Get e-commerce URL and redirect
      Common.getEcommerceUrl()
        .then(res => {
          const {
            Data: { url },
          } = res.data;
          if (url) {
            if (onSuccess) {
              onSuccess(url);
            } else {
              window.location = url;
            }
          } else {
            const errorMessage = "E-ticaret URL'i bulunamadı";
            console.error(errorMessage);
            if (onError) {
              onError(errorMessage);
            } else {
              this.handlePreOrderError(errorMessage);
            }
          }
        })
        .catch(error => {
          console.error('Preorder redirect error:', error);
          const errorMessage = 'Yönlendirme sırasında bir hata oluştu';
          if (onError) {
            onError(errorMessage);
          } else {
            this.handlePreOrderError(errorMessage);
          }
        });
    },

    /**
     * Default error handler for preorder redirect
     * @param {string} message - Error message
     */
    handlePreOrderError(message) {
      // Log the error message for debugging
      console.error('Preorder redirect error:', message);
      // Default error handling - redirect back to home after a delay
      setTimeout(() => {
        if (this.$router) {
          this.$router.push({ name: 'feed' });
        }
      }, 3000);
    },
  },
};
